<template>
    <div class="order-list">
        <header class="header-tab-container">
            <div v-for="tab in tabList" :key="tab.index"
                class="header-tab" :class="{'active': activeTabIndex === tab.index}"
                 @click="changeTab(tab['index'])">{{tab.label}}
            </div>
        </header>
        <div class="tip">
        温馨提示：本应用不提供照片的永久存储功能，冲印订单自付款成功之日30天后会自动删除，请尽早提取电子照
        </div>
        <section class="list-area">
            <div v-for="item in tabList" :key="item.index"
                v-show="item['index']===activeTabIndex"
                 class="list-item"
                 :class="{'scroll-style': item.value!=='waiting', 'active': item['index']===activeTabIndex}">
                <wait-pay ref="wait-pay"
                          v-if="item.value==='waiting'"
                          :view-data="item" :list-data="item['list']"
                          class="status-waiting"/>

                <mt-loadmore v-else style="min-height: 100%;" :top-method="reload"
                    :bottom-method="getOrders"
                    :bottom-all-loaded="item['isEnd']"
                    @top-status-change="handleTopStatusChange"
                    @bottom-status-change="handleBtnStatusChange" :ref="'loadmore_'+item['index']">
                    <div class="order-container" v-if="item['list'].length">
                        <template v-for="order in item['list']">
                            <order-card-mixed :key="order['id']" class="mix-order-card" v-if="!!order['order']"
                                              @deleteMergeOrder="showDeleteMergeConfirm"
                                              :view-data="order"/>
                            <order-card class="order-card"
                                        v-if="!order['order']&&order.state!=='canceled'"
                                        :view-data="order"
                                        @orderCardAction="(action) => orderCardAction(action, order['id'],order)"
                                        :key="order['id']"/>
                        </template>
                    </div>
                    <div class="empty-placehold" v-else-if="!(item['isLoading'] || pullDownActive)">这里空空如也～</div>
                    <loading :no-transition="true" :show="item['isLoading'] && !pullDownActive && !pullUpActive"/>


                    <div v-show="item['list'].length!==0 && item['isEnd']" class="_end">
                        <span>到底了</span>
                    </div>
                    <div slot="bottom" class="mint-loadmore-bottom" v-show="item['list'].length">
                        <loading :no-transition="true" :show="item['isLoading'] && !pullDownActive"/>
                    </div>
                </mt-loadmore>
            </div>
        </section>


        <!-- 合并支付优惠弹出提示 -->
        <mt-popup v-model="notifyShow"
                  :modalFade="true"
                  :lockScroll="true"
                  :close-on-click-modal="true"
                  popup-transition="popup-fade"
                  :modal="true">
            <div class="notify-box">
                <div class="_top">
                    <p class="_main _confirm">您确认取消当前订单？</p>
                </div>
                <div class="foot">
                    <button class="cancel-btn" @click="cancelOrderFn">是</button>
                    <button class="confirm-btn" @click="notifyShow=false">否</button>
                </div>
            </div>
        </mt-popup>

        <mt-popup v-model="payNotifyShow"
                  :modalFade="true"
                  :lockScroll="true"
                  :close-on-click-modal="true"
                  popup-transition="popup-fade"
                  :modal="true">
            <div class="notify-box">
                <div class="_top">
                    <p class="_main _confirm">你只选中了1单，确定放弃合并支付优惠吗？</p>
                </div>
                <div class="foot">
                    <button class="cancel-btn" @click="goPay">直接支付</button>
                    <button class="confirm-btn" @click="goCombinePay">合并支付</button>
                </div>
            </div>
        </mt-popup>
        <mt-popup v-model="deleteNotifyShow"
                  :modalFade="true"
                  :lockScroll="true"
                  :close-on-click-modal="true"
                  popup-transition="popup-fade"
                  :modal="true">
            <div class="notify-box">
                <div class="_top">
                    <p class="_main _confirm">删除后该订单将不会出现在订单列表中，您确认要删除该订单嘛？</p>
                </div>
                <div class="foot">
                    <button class="cancel-btn" @click="deleteMergeOrderFn">是</button>
                    <button class="confirm-btn" @click="deleteNotifyShow=false">否</button>
                </div>
            </div>
        </mt-popup>
    </div>
</template>

<script>
import {getPayType} from "@/utils/utils";
import Loading from "../components/Loadingb.vue";
import OrderCard from "../components/OrderCard.vue";
import OrderCardMixed from "../components/OrderCardMixed.vue";
import WaitPay from "../components/WaitPay.vue";
import {mapActions,mapState} from "vuex";
import {Toast, Loadmore} from 'mint-ui';

export default {
    name: 'OrderList',
    components: {OrderCard, OrderCardMixed, Loading, WaitPay, [Loadmore.name]: Loadmore},
    data() {
        return {
            activeTabIndex: 0,
            pullDownActive: false,
            notifyShow: false,
            cdorderstate:'',
            payNotifyShow: false,
            pullUpActive: false,
            deleteNotifyShow: false,
            deleteMergeOrderId: null,
            cancelOrderId: null,
            tabList: [
                {label: '全部', value: 'all', state: '', index: 0, list: [], cur_page: 0, 
                    isEnd: false, isLoading: false,},
                {label: '待付款', value: 'waiting', state: 'waiting', index: 1, list: [], cur_page: 0, 
                    isEnd: false, isLoading: false,},
                {label: '待发货', value: 'processing', state: 'processing', index: 2, list: [], cur_page: 0,
                    isEnd: false, isLoading: false,},
                {label: '待收货', value: 'shipping', state: 'shipping', index: 3, list: [], cur_page: 0, 
                    isEnd: false, isLoading: false,},
            ],
        }
    },
    computed:{
        ...mapState(['actiBol','platformInfo'])
    },
    activated(){
      if(!this.actiBol){
        return;
      }
      this.initData()
      this.handlequery()
      this.getOrders(true)
    },
    methods: {
        ...mapActions(["deleteOrderA","getMixOrder","printPay","deleteMergeOrder","cancelOrderA","modifyAddressA"]),
        handlequery(){
            console.log("有没有query:::",this.$route.query)
            let {state} = this.$route.query
            if(!state){
                return
            }
            let activeTabIndex = this.tabList.find(item => item.state === state).index
            this.changeTab(activeTabIndex)
            console.log("有没有值：：：",activeTabIndex)
        },
        showDeleteMergeConfirm(id) {
            this.deleteNotifyShow = true;
            this.deleteMergeOrderId = id;
        },
        deleteMergeOrderFn() {
            this.deleteMergeOrder(this.deleteMergeOrderId).then(()=> {
                this.deleteNotifyShow = false;

                this.$set(this.tabList[this.activeTabIndex], 'list', []);
                this.reload();
            })
        },
        initData(){
            this.activeTabIndex=0;
            this.cancelOrderId=null;
            this.notifyShow = false;
            this.payNotifyShow = false;
            this.payOrderId = null;
            this.tabList= [
                {label: '全部', value: 'all', state: '', index: 0, list: [], cur_page: 0, 
                    isEnd: false, isLoading: false,},
                {label: '待付款', value: 'waiting', state: 'waiting', index: 1, list: [], cur_page: 0, 
                    isEnd: false, isLoading: false,},
                {label: '待发货', value: 'processing', state: 'processing', index: 2, list: [], cur_page: 0,
                    isEnd: false, isLoading: false,},
                {label: '待收货', value: 'shipping', state: 'shipping', index: 3, list: [], cur_page: 0, 
                    isEnd: false, isLoading: false,},
            ]
        },
        // 点击切换 tab
        changeTab(tabIndex) {
            this.$set(this, 'activeTabIndex', tabIndex);
        },


        // 点击取消订单或者去支付
        orderCardAction(action, order_id,order) {
            if (action === 'cancel' || action === 'delete') {
                this.notifyShow = true;
                this.cancelOrderId = order_id;
                this.cdorderstate=action;
            } else if (action === 'pay') {
                this.payNotifyShow = true;
                this.payOrderId = order_id;
            } else if (action === 'modify'){
                this.$root.$on('modifyorder',this.modifyAddress)
                this.$router.push({
                    name:'addressManage',
                    params:{order}
                })
            }
        },
        modifyAddress(obj){
            this.modifyAddressA(obj).then(res=>{
                this.getOrders(true,true);
            })
        },
        cancelOrderFn() {
            if (this.cancelOrderId) {
                let fname = this.cdorderstate==='cancel'?this.cancelOrderA:this.deleteOrderA;
                fname.call(this,this.cancelOrderId).then(res => {
                    this.cancelOrderId = null;
                    this.notifyShow = false;
                    const waitingIndex = this.tabList.find(item => item.state === 'waiting').index;
                    const waitPayRef = this.$refs['wait-pay'][0];
                    this.$set(this.tabList[this.activeTabIndex], 'list', []);
                    // reset the waiting list while a order is cancelled.
                   const manualResetList = (index) => {
                        this.$set(this.tabList[index], 'list', []);
                        this.$set(this.tabList[index], 'isLoading', false);
                        this.$set(this.tabList[index], 'isEnd', false);
                        this.$set(this.tabList[index], 'cur_page', 0);
                        };
                    if (this.activeTabIndex === waitingIndex) {
                        manualResetList(0);
                        waitPayRef.reload();
                    } else {
                        manualResetList(waitingIndex);
                        this.reload();
                    }
                })
            }
        },

        goCombinePay() {
            this.payNotifyShow = false;
            this.changeTab(this.tabList.find(item => item.state==='waiting').index);
        },

        // 直接支付
        goPay() {
            console.log(this.payOrderId);
            if (!this.payOrderId) return;
            
            const currOrderItem = this.tabList[0].list.find(item => item.id === this.payOrderId);
            const type = 'single';
            this.payNotifyShow = false;

            let paramType = getPayType(this.platformInfo.platform,type);
            this.printPay({orderId:this.payOrderId, type:paramType}).then(res => {
                console.log(res);
                let payObj = {}
                if(this.platformInfo.platform === 'wechat'){
                    payObj = res.data.signed_string
                    payObj.orderId = currOrderItem.id;
                    payObj.description = "gopay";
                    payObj.type = type;
                }
                if(this.platformInfo.platform === 'baidu'){
                    payObj = {...res.data.orderInfo};
                    payObj.orderId = currOrderItem.id;
                    payObj.description = "gopay";
                    payObj.type = type;
                }
                this.sdk.gopay('pages/miniApi/miniApi', payObj);
            })
        },

        // 获取订单列表
        getOrders(isReload=false,noloading) {
            const tabIndex = this.activeTabIndex;
            const currTab = this.tabList[tabIndex];
            let targetPage = currTab['cur_page'] + 1;

            if (isReload) {
                currTab.isEnd = false;
                targetPage = 1;
            }

            // 如果正在加载或者已经加载了全部的数据，不再继续进行操作
            if (currTab.isLoading || currTab.isEnd) return Promise.resolve();
            !noloading&&this.$set(this.tabList[tabIndex], 'isLoading', true);
            
            // 构建请求数据
            const params = {
                page: targetPage,                       // 分页数据
                per_page: 15,                           // 每页数据
                total_required: true,                   // 是否需要返回总页数和总条目数
                state: currTab['state'],                // 订单状态
            };
            
            // 数据请求
            return this.getMixOrder(params).then(res=>{
                const order_list = res.data;
                if (order_list.length) { // 如果返回列表不为零，更新状态
                    currTab['list'] = isReload ? [...order_list] : [...currTab['list'], ...order_list];
                    currTab['cur_page'] = targetPage;
                } else {
                    currTab['isEnd'] = true;
                }

                currTab['isLoading'] = false;
                this.$set(this.tabList, tabIndex, currTab);
                this.pullUpActive = false;
                if (currTab['index'] !== 1 && targetPage!==1)
                    this.$refs['loadmore_'+ currTab['index']][0].onBottomLoaded();
            }, () => {
                this.pullUpActive = false;
                if (currTab['index'] !== 1 && !targetPage!==1)
                    this.$refs['loadmore_'+ currTab['index']][0].onBottomLoaded();
            })
        },

        handleTopStatusChange(status) {
            (status === 'loading') && this.$set(this, 'pullDownActive', true);
        },

        handleBtnStatusChange(status) {
            (status === 'loading') && this.$set(this, 'pullUpActive', true);
        },
        
        reload() {
            // console.log("刷新当前tab")
            // // 刷新当前 tab
            const tabIndex = this.activeTabIndex;
            const curr = this.tabList[tabIndex]

            this.getOrders(true).then(() => {
                setTimeout(() => {
                // 恢复下拉状态
                    this.$refs['loadmore_'+curr['index']]&&this.$refs['loadmore_'+curr['index']][0].onTopLoaded();
                    this.$set(this, 'pullDownActive', false);
                }, 300);
            });
        },
    },

    mounted () {
        // todo: 这里不异步会造成浏览器假死，原因未知
        // setTimeout(() => {
        //     let tabState = this.$route.query['tab'];
        //     if (tabState === 'waiting') {
        //         let tabIndex = this.tabList.find(item => item.state === 'waiting').index;
        //         this.changeTab(tabIndex);
        //     }
            
        //     this.getOrders().then(() => {
        //         this.$router.replace({ name: 'OrderList' });
        //     })
        // }, 50);
    },

    watch: {
        // 如果目标 tab 有数据则不初始化加载数据
        activeTabIndex(val) {
            if (this.tabList[val].list.length) return;
            this.getOrders();
        },
    },
}
</script>

<style scoped lang="scss">

.order-list {
    height: 100vh;
    overflow-x: hidden;
    .header-tab-container {
        width: 100vw;
        height: 0.32rem;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .header-tab {
            height: 0.32rem;
            line-height: 0.32rem;
            padding: 0 0.05rem;
            font-size: 0.14rem;
            border-bottom: 2px solid transparent;
            border-top: 2px solid transparent;
            color: #363636;
            transition: border 300ms, color 300ms;

            &.active {
                border-bottom: 2px solid #394BE5;
                color: #394BE5;
            }
        }
    }

    .list-area {
        width: 100vw;
        height: calc(100% - .8rem);
        position: relative;
        overflow: hidden;

        .list-item {
            width: 100%;
            height: 100%;
            will-change: transform;
            position: absolute;

            .order-container {    
                padding: 0.16rem;
                min-height: 100%;

                .order-card {
                    background-color: #fff;
                    padding: 0.16rem;
                    border-radius: 0.05rem;
                    margin-bottom: 0.16rem;
                }
            }
        }
    }
}

.scroll-style {
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
}

.empty-placehold {
    color: rgba(54, 54, 54, 0.7);
    font-size: 0.12rem;
    text-align: center;
    margin-top: 0.2rem;
}


._end {
    position: relative;
    width: 100%;
    height: 0.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(54, 54, 54, 0.3);
    font-size: 0.12rem;

    span {
        padding: 0 0.1rem;
    }

    &::before,
    &::after {
        content: '';
        width:0.2rem;
        height: 1px;
        border-top: 1px solid rgba(54, 54, 54, 0.2);
    }
}
.tip{
    font-size: .12rem;
    height:.48rem;
    color:#FC9C1D;
    background-color: rgba(252, 156, 29, 0.1);
    word-break: break-all;
    box-sizing: border-box;
    padding:.0 .2rem;
    display: flex;
    align-items: center;
}
</style>